<div mat-dialog-title>
  <h2>Detalles de la Solicitud</h2>
</div>

<mat-dialog-content>
  <div class="request-info">
    <div class="info-row">
      <strong>Tipo:</strong>
      <span>{{ getRequestTypeDisplay() }}</span>
    </div>
    <div class="info-row">
      <strong>Fechas:</strong>
      <span>{{ getRequestDaysDisplay() }}</span>
    </div>
    <div class="info-row">
      <strong>Duración:</strong>
      <span>{{ getDurationDays() }} día(s)</span>
    </div>
    <div class="info-row">
      <strong>Estado actual:</strong>
      <span [class]="'status-badge status-' + request.status">
        {{ getStatusDisplay(request.status) }}
      </span>
    </div>
  </div>

  <div class="history-section">
    <h3>Historial de Cambios</h3>

    @if (request.status_history && request.status_history.length > 0) {
    <div class="timeline">
      @for (history of request.status_history; track history.id) {
      <div class="timeline-item">
        <div class="timeline-marker"></div>
        <div class="timeline-content">
          <div class="timeline-header">
            <span class="timeline-change">
              <span [class]="'status-badge-small status-' + history.old_status">
                {{ getStatusDisplay(history.old_status) }}
              </span>
              <mat-icon>arrow_forward</mat-icon>
              <span [class]="'status-badge-small status-' + history.new_status">
                {{ getStatusDisplay(history.new_status) }}
              </span>
            </span>
            <span class="timeline-date">{{ formatDate(history.created_when) }}</span>
          </div>
          <div class="timeline-details">
            <div>
              <strong>Modificado por:</strong>
              {{ history.changed_by_details.first_name }} {{ history.changed_by_details.last_name || '' }}
              ({{ history.changed_by_details.username | qeqPipe}})
            </div>
            @if (history.comment) {
            <div class="comment">
              <strong>Comentario:</strong> {{ history.comment }}
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
    } @else {
    <p class="no-history">No hay historial de cambios disponible.</p>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button class="cancel" (click)="close()">Cerrar</button>
</mat-dialog-actions>